import styles from './Spinner.module.sass';

export default function Spinner() {
  return (
    <span className={styles.spinner}></span>
  );
}
